module.exports = __webpack_public_path__ + "img/download.ddc79fe8.png";